import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8a316dca"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled"]
const _hoisted_2 = { class: "flex align-items-center justify-content-between flex-wrap sm:flex-nowrap" }
const _hoisted_3 = { class: "drag-icon -ml-s2" }
const _hoisted_4 = { class: "flex-center sm:justify-content-start" }
const _hoisted_5 = {
  key: 0,
  class: "caption ml-s2"
}
const _hoisted_6 = {
  key: 0,
  class: "token-notice mt-s1"
}
const _hoisted_7 = { class: "w-2rem sm:flex-order-5 flex" }
const _hoisted_8 = { class: "sm:ml-auto gutter-y-s1 flex flex-column sm:align-items-end" }
const _hoisted_9 = {
  key: 1,
  class: "token-amount"
}
const _hoisted_10 = {
  key: 2,
  class: "caption flex align-items-center gutter-x-s1 flex-wrap sm:justify-content-end white-space-nowrap sm:flex-nowrap"
}
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 3,
  class: "caption flex align-items-center gutter-x-s1 white-space-nowrap sm:flex-nowrap"
}
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  key: 0,
  class: "token-notice mt-s2 w-full"
}

import { useTokenBalance } from '@/composables/token/useTokenBalance';
import { TokenInfo } from '@/sdk/entities/portfolio';
import { findLastIndex, moveItem } from '@/utils/array';
import { useEasyModeForm } from '@/views/pages/liquidity/portfolios/portfolio/liquidity-management/easy-mode/composables/useEasyModeForm';
import {
  EasyModeAddLiquidityForm,
  EasyModeWithdrawForm,
} from '@/views/pages/liquidity/portfolios/portfolio/liquidity-management/easy-mode/models/easy-mode-form';
import {
  EasyModeAddLiquidityToken,
  EasyModeCommonToken,
  EasyModeToken,
  EasyModeWithdrawToken,
} from '@/views/pages/liquidity/portfolios/portfolio/liquidity-management/easy-mode/models/easy-mode-token';
import { computed, ComputedRef, watch } from 'vue';
import TokenIcon from '@/components/token/TokenIcon.vue';
import Icon from '@/components/icon/Icon.vue';
import TokenNotice from '@/views/pages/liquidity/portfolios/portfolio/liquidity-management/easy-mode/common/tokens-list/TokenNotice.vue';
import { formatNumbersMixin } from '@/mixins/format-numbers.mixin';
import { compareTokenAddresses } from '@/sdk/utils';
import { TOKEN_NOTICE_TYPES } from '@/views/pages/liquidity/portfolios/portfolio/liquidity-management/common/constants/TOKEN_NOTICE_TYPES';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'Token',
  props: {
    address: null,
    forceDisables: { type: Boolean },
    draggable: { type: Boolean },
    currentAction: null
  },
  setup(__props: any) {

const props = __props as {
  address: string;
  forceDisables?: boolean;
  draggable?: boolean;
  currentAction: string;
}

const { easyModeForm, getPortfolioAvailableTokens, calculateHowManyTokensCanBridgeFromCardano } =
  useEasyModeForm();
const { format } = formatNumbersMixin.methods;
const { state } = useStore();
const { t } = useI18n();



const action = easyModeForm.action;

const token = computed(
  () =>
    (easyModeForm.tokens as EasyModeToken[]).find(token =>
      compareTokenAddresses(token.address, props.address),
    )!,
);

const tokenInfo: ComputedRef<TokenInfo> = computed(
  () =>
    getPortfolioAvailableTokens(easyModeForm.portfolio).find(tokenInfo =>
      compareTokenAddresses(tokenInfo.tokenAddress, props.address),
    )!,
);

const usdTokenPrice = computed(() => {
  if (!tokenInfo.value || !easyModeForm.portfolio) {
    return '0';
  }

  return format(easyModeForm.portfolio.getTokenPriceInUSD(tokenInfo.value, props.currentAction));
});

const canShowNotice = computed(
  () =>
    !!(
      (easyModeForm as EasyModeAddLiquidityForm).baseTokenAmount?.gt(0) ||
      (easyModeForm as EasyModeWithdrawForm).lpTokenAmount?.gt(0)
    ),
);

const balance = useTokenBalance(
  computed(() => tokenInfo.value?.token),
  {
    subTxFeeFromNativeBalance: true,
    countHowManyCanBridgeFromCardano: calculateHowManyTokensCanBridgeFromCardano(),
  },
);

const checkboxChanged = (token: EasyModeCommonToken) => {
  if (!props.forceDisables) {
    const tokens = easyModeForm.tokens as EasyModeToken[];
    token.checked = !token.checked;
    const currentTokenIndex = easyModeForm.tokens.findIndex(formToken =>
      compareTokenAddresses(token.address, formToken.address),
    );
    const lastCheckedTokenIndex = findLastIndex(
      tokens,
      formToken => formToken.checked && !compareTokenAddresses(formToken.address, token.address),
    );

    const newIndex =
      currentTokenIndex < lastCheckedTokenIndex ? lastCheckedTokenIndex : lastCheckedTokenIndex + 1;

    easyModeForm.tokens = moveItem(tokens, currentTokenIndex, newIndex) as
      | EasyModeWithdrawToken[]
      | EasyModeAddLiquidityToken[];
  }
};

watch(balance, updateNotice, { immediate: true });

function updateNotice(balance: string) {
  const balanceIsZero = !balance || balance === '0';
  const isAddLiquidity = easyModeForm.action === 'addLiquidity';
  const isWithinBalances = (easyModeForm as EasyModeAddLiquidityForm).withinBalances;

  if (balanceIsZero && isAddLiquidity && isWithinBalances) {
    token.value!.notice = {
      type: TOKEN_NOTICE_TYPES.ZERO_BALANCE,
    };
  }
}

return (_ctx: any,_cache: any) => {
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass(["panel-token", { checked: _unref(token).checked && !props.forceDisables }]),
      disabled: _unref(token).disabled || props.forceDisables
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (__props.draggable && !props.forceDisables)
            ? (_openBlock(), _createBlock(Icon, {
                key: 0,
                name: "drag",
                class: "text-muted cursor-move",
                size: "20"
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(TokenIcon, {
              "icon-src": _unref(tokenInfo).token.tokenIconUrl,
              symbol: _unref(tokenInfo).token.unwrapWETH().symbol,
              full: ""
            }, null, 8, ["icon-src", "symbol"]),
            (!_unref(state).layout.isMobile)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(t)('price')) + ": $" + _toDisplayString(_unref(usdTokenPrice)), 1))
              : _createCommentVNode("", true)
          ]),
          (_unref(token).notice && !_unref(state).layout.isMobile && _unref(canShowNotice))
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(TokenNotice, {
                  notice: _unref(token).notice,
                  symbol: _unref(tokenInfo).token.unwrapWETH().symbol,
                  action: _unref(easyModeForm).action,
                  onOnSelectToken: _cache[0] || (_cache[0] = ($event: any) => (_unref(token).checked = !_unref(token).checked))
                }, null, 8, ["notice", "symbol", "action"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_Checkbox, {
            class: "ml-auto",
            "model-value": !props.forceDisables && _unref(token).checked,
            binary: true,
            onChange: _cache[1] || (_cache[1] = ($event: any) => (checkboxChanged(_unref(token)))),
            disabled: __props.forceDisables
          }, null, 8, ["model-value", "disabled"])
        ]),
        (_unref(state).layout.isMobile)
          ? (_openBlock(), _createBlock(_component_Divider, {
              key: 0,
              class: "divider-nm"
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_8, [
          (!_unref(token).amount)
            ? (_openBlock(), _createBlock(_component_Skeleton, {
                key: 0,
                class: "w-7rem",
                height: "1.5rem"
              }))
            : _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createTextVNode(_toDisplayString(_unref(format)(_unref(token).amount)) + " " + _toDisplayString(_unref(tokenInfo).token.unwrapWETH().symbol), 1)
              ])), [
                [
                  _directive_tooltip,
                  _unref(token).amount?.decimalPlaces(_unref(tokenInfo)?.token.decimals).toFixed(),
                  void 0,
                  { top: true }
                ]
              ]),
          (_unref(action) === 'addLiquidity')
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("span", null, _toDisplayString(_unref(t)('balance')) + ":", 1),
                (!_unref(balance))
                  ? (_openBlock(), _createBlock(_component_Skeleton, {
                      key: 0,
                      class: "w-7rem"
                    }))
                  : (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_unref(format)(_unref(balance))) + " " + _toDisplayString(_unref(tokenInfo).token.unwrapWETH().symbol), 1))
              ]))
            : _createCommentVNode("", true),
          (_unref(action) === 'withdraw')
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("span", null, _toDisplayString(_unref(t)('portfolio.withdraw.noLossLimit')) + ":", 1),
                (!_unref(token).noLossLimit)
                  ? (_openBlock(), _createBlock(_component_Skeleton, {
                      key: 0,
                      class: "w-7rem"
                    }))
                  : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_unref(format)(_unref(token).noLossLimit)), 1))
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      (_unref(token).notice && _unref(state).layout.isMobile && _unref(canShowNotice))
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createVNode(TokenNotice, {
              notice: _unref(token).notice,
              symbol: _unref(tokenInfo).token.unwrapWETH().symbol,
              action: _unref(easyModeForm).action,
              onOnSelectToken: _cache[2] || (_cache[2] = ($event: any) => (_unref(token).checked = !_unref(token).checked))
            }, null, 8, ["notice", "symbol", "action"])
          ]))
        : _createCommentVNode("", true)
    ], 10, _hoisted_1)
  ]))
}
}

})